var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningToast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.50002,
    y: 5.49984,
    width: 25,
    height: 25,
    rx: 12.5,
    stroke: "#DC6803",
    strokeWidth: 1.66667
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.33333,
    y: 1.33333,
    width: 33.3333,
    height: 33.3333,
    rx: 16.6667,
    stroke: "#DC6803",
    strokeWidth: 1.66667
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3469_1395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 14.6665V17.9998M18 21.3332H18.0084M26.3334 17.9998C26.3334 22.6022 22.6024 26.3332 18 26.3332C13.3976 26.3332 9.66669 22.6022 9.66669 17.9998C9.66669 13.3975 13.3976 9.6665 18 9.6665C22.6024 9.6665 26.3334 13.3975 26.3334 17.9998Z",
    stroke: "#DC6803",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3469_1395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningToast);
export default __webpack_public_path__ + "static/media/warningToast.45d03f23aa49214579d8cce9fa7bc2ac.svg";
export { ForwardRef as ReactComponent };